import { Component, Input, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

export interface GoalsExportRange {
    startDate: Date
    endDate: Date
}

@Component({
    selector: 'app-goals-export-modal',
    templateUrl: './goals-export-modal.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule],
})
export class GoalsExportModalComponent {
    private activeModal = inject(NgbActiveModal)

    /** Default start date for the range (e.g. earliest week in the grid). */
    @Input() minDate: Date = new Date()
    /** Default end date for the range (e.g. latest week in the grid). */
    @Input() maxDate: Date = new Date()

    /** Selected start date for range export (parent may set after open). */
    startDate: Date = new Date()
    /** Selected end date for range export (parent may set after open). */
    endDate: Date = new Date()

    exportAll() {
        this.activeModal.close(null)
    }

    exportRange() {
        let start = new Date(this.startDate)
        let end = new Date(this.endDate)
        if (start > end) {
            ;[start, end] = [end, start]
        }
        this.activeModal.close({ startDate: start, endDate: end } as GoalsExportRange)
    }

    cancel() {
        this.activeModal.dismiss()
    }
}
